import { render, staticRenderFns } from "./ItemsMapTpl.vue?vue&type=template&id=03552ab8"
import script from "./ItemsMapTpl.vue?vue&type=script&lang=js"
export * from "./ItemsMapTpl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports